import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import autoMessageService from "..";
import { MerchantCustomerNotifierPayload } from "../request";

function useChangeCustomerNotifier() {
  const queryClient = useQueryClient();
  const {
    mutate: changeCustomerNotifierMerchant,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: MerchantCustomerNotifierPayload) => {
      return autoMessageService.changeAutoMessageConfig(command);
    },
    onSuccess: () => {
      notifications.show({
        title: "عملیات موفق",
        message: "عملیات با موفقیت صورت پذیرفت",
        color: "green",
      });
      queryClient.invalidateQueries({ queryKey: ["getCustomerNotifier"] });
    },
  });
  return { changeCustomerNotifierMerchant, isLoading, isSuccess };
}

export default useChangeCustomerNotifier;
